import { LoginData } from "@/components/Portal/UserAccount/Security/LoginData";
import { MagicLinkLoginSetting } from "@/components/Portal/UserAccount/Security/MagicLinkLoginSetting";
import { TwoFactorAuthStatus } from "@/components/Portal/UserAccount/Security/TwoFactorAuthStatus";

export const SecurityView = () => (
  <div className="flex flex-col gap-8">
    <LoginData />
    <MagicLinkLoginSetting />
    <TwoFactorAuthStatus />
  </div>
);
